<app-contentful-renderer [model]="item" *ngFor="let item of model.layout"></app-contentful-renderer>
